import type { BlogCategory } from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'

import * as styles from './blog-list-categories.styles'

type BlogListCategoriesProps = {
  currentCategoryId?: string | number
  categories: BlogCategory[]
  handleCategoryChange: (categoryId: string | number | undefined) => void
}

export const BlogListCategories = ({
  categories,
  currentCategoryId,
  handleCategoryChange,
}: BlogListCategoriesProps) => {
  const { staticTexts } = useAdditionalData()

  return (
    <div css={styles.categories}>
      <button
        css={[styles.category, !currentCategoryId && styles.activeCategory]}
        onClick={() => handleCategoryChange(undefined)}
      >
        {staticTexts?.allCategories || ''}
      </button>

      {categories.map((category) => (
        <button
          key={category.id}
          css={[
            styles.category,
            currentCategoryId === category.id && styles.activeCategory,
          ]}
          onClick={() => handleCategoryChange(category.id)}
        >
          {category.name}
        </button>
      ))}
    </div>
  )
}
